export class TherapistSchedule {

    public relations = ['therapist'];

    public profile_fields = ['therapist__user_id'];


    public names = {
        therapist__user_id: function (data) {
            return data.therapist && (data.therapist.f + ' ' + data.therapist.i + ' '  + data.therapist.o);
        },
    }
}
